function e(e,n){if(null==e)return{};var r,t,f={},u=Object.keys(e);for(t=0;t<u.length;t++)r=u[t],n.indexOf(r)>=0||(f[r]=e[r]);return f}export default e;
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
